module.exports = __webpack_public_path__ + "img/sidebar-battery-2.78837910.svg";